<template>
    <div>
        <div class="custom-info-item">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_CONTACT_NO') }}</span>
            <span class="custom-info-item__value">{{ getFieldValue('contact_no') }}</span>
        </div>
        <div class="custom-info-item">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_CREATION_DATE') }}</span>
            <span class="custom-info-item__value">{{ creationDate }}</span>
        </div>
        <div class="custom-info-item">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_CONTACT_ORIGIN') }}</span>
            <span class="custom-info-item__value">{{ getFieldValue('leadsource') }}</span>
        </div>
        <hr>
        <div class="custom-info-item custom-info-item--button-holder">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_PORTABILITY_RIGHT') }}</span>
            <span class="custom-info-item__value">
                <ini-button @click.native="exportData" icon="cloud-download">{{ $t('LBL_GDPR_DOWNLOAD_MY_DATA') | uppercase }}</ini-button>
            </span>
        </div>
        <div class="custom-info-item custom-info-item--button-holder custom-info-item--delete">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_GDPR_FORGOTTEN_RIGHT') }}</span>
            <span class="custom-info-item__value">
                <ini-button @click.native="forgetMe" icon="delete">{{ $t('LBL_GDPR_DELETE_MY_DATA') | uppercase }}</ini-button>
            </span>
        </div>
        <div class="custom-info-item custom-info-item--button-holder">
            <span class="custom-info-item__label">{{ this.$t('LBL_GDPR_MORE_INFO') }}</span>
            <span class="custom-info-item__value">
                <a :href="'mailto:' + getSettingValue('dpo_email')">{{ getSettingValue('dpo_email') }}</a>
            </span>
        </div>
    </div>
</template>

<script>
    import IniButton from '@/components/Button'
    import StyleMixin from '@/mixins/StyleMixin'
    import swal from "sweetalert2";

    export default {
        mixins: [StyleMixin],

        components: {
            IniButton
        },

        data() {
            return {
                forgetMeLoader: false,
            }
        },

        props: [
            'fields',
            'settings'
        ],

        computed: {
            creationDate() {
                let createdTime = this.getField('createdtime');
                return this.transformDateTime(createdTime, false).displayValue;
            }
        },

        methods: {
            async exportData() {
                // Prevents duplicate api call
                if(this.exportLoader){
                    return;
                }

                this.exportLoader = true
                var response = await Api.export()
                this.exportLoader = false

                if(response.success){
                    AppHelper.notify(this.$t('LBL_EXPORT_DONE'), 'info')
                }else{
                    AppHelper.notify('Error occurred', 'warning')
                }
            },

            async forgetMe() {
                // Prevents duplicate api call
                if(this.forgetMeLoader){
                    return;
                }

                this.forgetMeLoader = true
                var data = await this.showForgetMeConfirmationAlert()

                if(data.value){
                    await Api.forgetMe()
                    await Api.logout()
                    this.$router.push({name: 'Login'})
                }
                this.forgetMeLoader = false
            },

            async showForgetMeConfirmationAlert() {
                return await swal({
                    title: this.$t('LBL_ARE_YOU_SURE'),
                    text: this.$t('LBL_FORGET_ME_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    confirmButtonText: this.$t('LBL_FORGET_ME_CONFIRM'),
                    cancelButtonClass: 'btn btn-secondary',
                    cancelButtonText: this.$t('LBL_CANCEL')
                })
            },

            getField(fieldName) {
                return this.fields.find(field => field.name == fieldName);
            },

            getFieldValue(fieldName) {
                let field = this.getField(fieldName);
                if(field && field.displayValue) {
                    return field.displayValue;
                }
                return '-';
            },
            
            getSettingValue(settingName){
                return this.settings[settingName];
            }
        },
    }
</script>
<style lang="scss">@import "@/assets/scss/components/GDPR/_custom.scss";</style>